import React from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'

import Leagues from './Leagues.jsx'

import LiveMenu from './LiveMenu.jsx'
import PreMatchMenu from './PreMatchMenu.jsx'
import PerfectScrollbar from 'react-perfect-scrollbar'

const messages = defineMessages({
  live_matches: {
    id: 'grid.header.live.matches',
    defaultMessage: 'Live матчи',
  },
  event: {
    id: 'grid.header.event',
    defaultMessage: 'Ставки на спорт',
  },
  live_bets_online: {
    id: 'grid.header.live_bets_online',
    defaultMessage: ' live ставки онлайн',
  },
  football: {
    id: 'grid.header.football',
    defaultMessage: 'Футбол',
  },
  tennis: {
    id: 'grid.header.tennis',
    defaultMessage: 'Теннис',
  },
  volleyball: {
    id: 'grid.header.volleyball',
    defaultMessage: 'Волейбол',
  },
  handball: {
    id: 'grid.header.handball',
    defaultMessage: 'Гандбол',
  },
  hockey: {
    id: 'grid.header.hockey',
    defaultMessage: 'Хоккей',
  },
  cyberSport: {
    id: 'grid.header.cybersport',
    defaultMessage: 'Киберспорт',
  },
  basketball: {
    id: 'grid.header.basketball',
    defaultMessage: 'Баскетбол',
  },
  boxing: {
    id: "grid.header.boxing",
    defineMessages: "Ставки на бокс онлайн",
  },
  UFC_MMA: {
    id: "grid.header.UFC_MMA",
    defineMessages: "Ставки на UFC и MMA онлайн",
  },
  american_football: {
    id: "grid.header.american_football",
    defineMessages: "Ставки на американский футбол онлайн",
  },
  table_tennis: {
    id: "grid.header.table_tennis",
    defineMessages: "Ставки на настольный теннис онлайн",
  },
  win1: {
    id: 'grid.header.win1',
    defaultMessage: 'П1',
  },
  draw: {
    id: 'grid.header.draw',
    defaultMessage: 'X',
  },
  win2: {
    id: 'grid.header.win2',
    defaultMessage: 'П2',
  },
  win1draw: {
    id: 'grid.header.win1_draw',
    defaultMessage: '1X',
  },
  win12: {
    id: 'grid.header.win12',
    defaultMessage: '12',
  },
  drawWin2: {
    id: 'grid.header.draw_win2',
    defaultMessage: 'X2',
  },
  handicap: {
    id: 'grid.header.handicap',
    defaultMessage: 'ФОРА',
  },
  handicap1: {
    id: 'grid.header.handicap1',
    defaultMessage: '1',
  },
  handicap2: {
    id: 'grid.header.handicap2',
    defaultMessage: '2',
  },
  under: {
    id: 'grid.header.under',
    defaultMessage: 'МЕН',
  },
  total: {
    id: 'grid.header.total',
    defaultMessage: 'ТОТ',
  },
  over: {
    id: 'grid.header.over',
    defaultMessage: 'БОЛ',
  },
  allTime: {
    id: 'grid.menu.prematch_filter.all_time',
    defaultMessage: 'За всё время',
  },
  nextHour: {
    id: 'grid.menu.prematch_filter.next_hour',
    defaultMessage: 'Ближайший час',
  },
  next2Hours: {
    id: 'grid.menu.prematch_filter.next_2_hours',
    defaultMessage: 'Ближайшие 2 часа',
  },
  next4Hours: {
    id: 'grid.menu.prematch_filter.next_4_hours',
    defaultMessage: 'Ближайшие 4 часа',
  },
  next6Hours: {
    id: 'grid.menu.prematch_filter.next_6_hours',
    defaultMessage: 'Ближайшие 6 часов',
  },
  next12Hours: {
    id: 'grid.menu.prematch_filter.next_12_hours',
    defaultMessage: 'Ближайшие 12 часов',
  },
  nextDay: {
    id: 'grid.menu.prematch_filter.next_day',
    defaultMessage: 'Ближайший день',
  },
  next2Days: {
    id: 'grid.menu.prematch_filter.next_2_days',
    defaultMessage: 'Ближайшие 2 дня',
  },
})

const HeaderItem = ({ message }) => (
  <FormattedMessage {...message}>
    {(m) => <span className='cell cell-outcomes'>{m}</span>}
  </FormattedMessage>
)

export default class Grid extends React.Component {
  static propTypes = {
    section: React.PropTypes.string.isRequired,
    gridLocalization: React.PropTypes.object.isRequired,
    expandAllMatchesAction: React.PropTypes.func.isRequired,
    collapseAllMatchesAction: React.PropTypes.func.isRequired,
    expandAllGroupsAction: React.PropTypes.func.isRequired,
    collapseAllGroupsAction: React.PropTypes.func.isRequired,
    showLineNumbersAction: React.PropTypes.func.isRequired,
    hideLineNumbersAction: React.PropTypes.func.isRequired,
    matchId: React.PropTypes.any,
    gridSelection: React.PropTypes.object.isRequired,
    selectionToggleMatchAction: React.PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = { showMenu: false, filter: null }

    this._handleMenuClose = this._handleMenuClose.bind(this)
    this._handleShowMenuClick = this._handleShowMenuClick.bind(this)
    this._handleExpandAllMatchesClick = this._handleExpandAllMatchesClick.bind(this)
    this._handleCollapseAllMatchesClick = this._handleCollapseAllMatchesClick.bind(this)
    this._handleExpandAllGroupsClick = this._handleExpandAllGroupsClick.bind(this)
    this._handleCollapseAllGroupsClick = this._handleCollapseAllGroupsClick.bind(this)
    this._handleDisplayLineNumbersClick = this._handleDisplayLineNumbersClick.bind(this)
    this._handleHideLineNumbersClick = this._handleHideLineNumbersClick.bind(this)

    this._handleFilterClick = this._handleFilterClick.bind(this)

    this._handleWidthAdjust = this._handleWidthAdjust.bind(this)
  }

  componentDidMount() {
    this._widthAdjustmentInterval = window.setInterval(this._handleWidthAdjust, 500)
  }

  componentWillUnmount() {
    if (this._widthAdjustmentInterval) {
      window.clearInterval(this._widthAdjustmentInterval)
    }
  }

  _handleMenuClose() {
    const state = this.state

    this.setState({
      ...state,
      showMenu: false,
    })
  }

  _handleShowMenuClick(e) {
    e.preventDefault()

    const state = this.state

    this.setState({
      ...state,
      showMenu: true,
    })
  }

  _handleExpandAllMatchesClick(e) {
    e.preventDefault()

    this.props.expandAllMatchesAction()
  }

  _handleCollapseAllMatchesClick(e) {
    e.preventDefault()

    this.props.collapseAllMatchesAction()
  }

  _handleExpandAllGroupsClick(e) {
    e.preventDefault()

    this.props.expandAllGroupsAction()
  }

  _handleCollapseAllGroupsClick(e) {
    e.preventDefault()

    this.props.collapseAllGroupsAction()
  }

  _handleDisplayLineNumbersClick(e) {
    e.preventDefault()

    this.props.showLineNumbersAction(this.props.section)
  }

  _handleHideLineNumbersClick(e) {
    e.preventDefault()

    this.props.hideLineNumbersAction(this.props.section)
  }

  _handleWidthAdjust() {
    const contentWidth = this.refs.content.offsetWidth
    const contentHeight = this.refs.content.offsetHeight
    const titleWidth = this.refs.title.offsetWidth

    if (contentHeight !== this.state.contentHeight) {
      this.setState({ contentHeight })
      this.refs._scrollBarRef.updateScroll()
    }

    if (contentWidth !== titleWidth) {
      this.refs.title.style.width = contentWidth + 'px'
    }
  }

  _handleFilterClick(filter) {
    const state = this.state
    this.props.changeFilter(filter)
    this.setState({
      ...state,
      filter,
    })
  }

  getPageH1(sportId) {
    const formattedMessage = (h1, phrase) => {
      const title = <FormattedMessage {...h1} />;
      const message = phrase ? <FormattedMessage {...messages.live_bets_online} /> : null;

      return (
        <h1 style={{ display: 'inline-block' }}>
          {title}
          {message}
        </h1>
      );
    }
    switch (sportId) {
      case '4': {
        return formattedMessage(messages.volleyball, true)
      }
      case '6': {
        return formattedMessage(messages.tennis, true)
      }
      case '7': {
        return formattedMessage(messages.football, true)
      }
      case '19': {
        return formattedMessage(messages.handball, true)
      }
      case '30': {
        return formattedMessage(messages.hockey, true)
      }
      case '31': {
        return formattedMessage(messages.basketball, true)
      }
      case '38': {
        return formattedMessage(messages.cyberSport, true)
      }
      case '5': {
        return formattedMessage(messages.boxing)
      }
      case '39': {
        return formattedMessage(messages.UFC_MMA)
      }
      case '11': {
        return formattedMessage(messages.american_football)
      }
      case '2': {
        return formattedMessage(messages.table_tennis)
      }
      default: {
        return formattedMessage(messages.event)
      }
    }
  }

  render() {
    const { section, gridLocalization, matchId, gridSelection, selectionToggleMatchAction, sportId } = this.props
    const { showMenu, filter } = this.state

    let selectedTitle = messages.allTime
    switch (filter) {
      case 1:
        selectedTitle = messages.nextHour
        break
      case 2:
        selectedTitle = messages.next2Hours
        break
      case 4:
        selectedTitle = messages.next4Hours
        break
      case 6:
        selectedTitle = messages.next6Hours
        break
      case 12:
        selectedTitle = messages.next12Hours
        break
      case 24:
        selectedTitle = messages.nextDay
        break
      case 48:
        selectedTitle = messages.next2Days
        break
    }

    return (
      <div id='live-content'>
        <div className='live-titles scroll--top' ref='title'>
          <div className='table main-heading'>
            {section === 'live' &&
              <a href='#' className='events-toggle' onClick={this._handleShowMenuClick}>{'\u00A0'}</a>}
            {section === 'live' && showMenu &&
              <LiveMenu onShowClickCallback={this._handleShowMenuClick}
                        onCollapseAllMatchesClick={this._handleCollapseAllMatchesClick}
                        onExpandAllMatchesClick={this._handleExpandAllMatchesClick}
                        onCollapseAllGroupsClick={this._handleCollapseAllGroupsClick}
                        onExpandAllGroupsClick={this._handleExpandAllGroupsClick}
                        onDisplayLineNumbersClick={this._handleDisplayLineNumbersClick}
                        onHideLineNumbersClick={this._handleHideLineNumbersClick}
                        onClosing={this._handleMenuClose}
              />}
            <div className='row'>
                            <span className='cell main'>
                                {section === 'live' &&
                                  <FormattedMessage {...messages.live_matches}>
                                    {(title) => <h1 onClick={this._handleShowMenuClick}>{title}</h1>}
                                  </FormattedMessage>}
                              {section !== 'live' && this.getPageH1(sportId)}
                              {section === 'preMatch' &&
                                <div className='pull-right'>
                                  <div className='schedule--events'>
                                    <a href='#' className='dropdown--toggle'
                                       onClick={this._handleShowMenuClick}>
                                      <FormattedMessage {...selectedTitle} />
                                    </a>
                                    {showMenu &&
                                      <PreMatchMenu onFilterClick={this._handleFilterClick}
                                                    onClosing={this._handleMenuClose}
                                                    activeElement={filter} />}
                                  </div>
                                </div>}
                            </span>
              <HeaderItem message={messages.win1} />
              <HeaderItem message={messages.draw} />
              <HeaderItem message={messages.win2} />
              <HeaderItem message={messages.win1draw} />
              <HeaderItem message={messages.win12} />
              <HeaderItem message={messages.drawWin2} />
              <HeaderItem message={messages.handicap} />
              <HeaderItem message={messages.handicap1} />
              <HeaderItem message={messages.handicap} />
              <HeaderItem message={messages.handicap2} />
              <HeaderItem message={messages.under} />
              <HeaderItem message={messages.total} />
              <HeaderItem message={messages.over} />
            </div>
          </div>
        </div>
        <div className='scroll--wrapper'>
          <PerfectScrollbar ref='_scrollBarRef'>
            <div className='scroll--wrapper__inner' ref='content'>
              <Leagues section={section}
                       gridLocalization={gridLocalization}
                       filter={filter}
                       matchId={matchId}
                       gridSelection={gridSelection}
                       selectionToggleMatchAction={selectionToggleMatchAction}
                       currentPage={this.props.currentPage}
                       perPage={this.props.perPage}
                       changePaginationItemCount={this.props.changePaginationItemCount}
              />
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/Grid.jsx